import moment from "moment";
import { LoadState } from "../../constants/enums";
import { defaultMasterProduct } from "../masterCategories/masterCategories.state";
import { IJobs, IJobsState, IPurchaseRequisitionItem } from "./jobs_types";
import { initialProductsState } from "../products/products.types";

export const defaultPurchaseRequisitionItem: IPurchaseRequisitionItem = {
  ...defaultMasterProduct,
  quantity: 0,
  discount: 0,
  discount_amount: 0,
  cess_rate: 0,
  taxable_amount: 0,
  gst_amount: 0,
  tax_type: "IGST",
  total: 0,
  reserved_quantity: 0,
  sub_total: 0,
};

export const initialJobs: IJobs = {
  job_uuid: null,
  job_order_no: "",
  job_order_date: moment().format("YYYY-MM-DD"),
  job_name: "",
  project_uuid: "",
  project_name: "",
  project_manager_uuid: "",
  project_manager_name: "",
  finance_manager_uuid: "",
  finance_manager_name: "",
  vendor_uuid: null,
  vendor_name: null,
  attachment: [],
  status: "DRAFT",
  billing_company_uuid: null,
  billing_company_name: null,
  billing_company_branch_uuid: null,
  billing_company_branch_name: null,
  billing_company_branch_address_state: null,
  requested_by_uuid: "",
  additional_fields: [],
  expected_delivery_date: moment().format("YYYY-MM-DD"),
  due_date: "",
  priority: null,
  pr_items: [defaultPurchaseRequisitionItem],
  pr_category: null,
  // delivery_address_state: null,
};
export const initialJobsState: IJobsState = {
  jobsList: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  jobsData: {
    data: initialJobs,
    loading: LoadState.NotLoaded,
    error: null,
  },
  jobs_approval_ist: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
